import { cn } from "./cn";

export type LoaderProps = {
  variant?: "text-shimmer" | "circular";
  size?: "sm" | "md" | "lg";
  text?: string;
  className?: string;
};

const textSizes = { sm: "text-xs", md: "text-sm", lg: "text-base" };
const ringSizes = { sm: "h-4 w-4", md: "h-5 w-5", lg: "h-6 w-6" };

function TextShimmerLoader({
  text = "Thinking",
  size = "md",
  className,
}: Omit<LoaderProps, "variant">) {
  return (
    <div
      role="status"
      className={cn(
        "animate-shimmer bg-clip-text font-medium text-transparent",
        textSizes[size!],
        className
      )}
      style={{
        backgroundImage:
          "linear-gradient(to right, #9CA3AF 40%, #1F2937 50%, #9CA3AF 60%)",
        backgroundSize: "200% auto",
      }}
    >
      {text}
    </div>
  );
}

function CircularLoader({
  size = "md",
  className,
}: Omit<LoaderProps, "variant" | "text">) {
  return (
    <div
      role="status"
      className={cn(
        "animate-spin rounded-full border-2 border-gray-200 border-t-gray-400",
        ringSizes[size!],
        className
      )}
    >
      <span className="sr-only">Loading</span>
    </div>
  );
}

export function Loader({
  variant = "text-shimmer",
  size = "md",
  text,
  className,
}: LoaderProps) {
  if (variant === "circular")
    return <CircularLoader size={size} className={className} />;
  return <TextShimmerLoader size={size} text={text} className={className} />;
}
